import { BrowserMultiFormatReader } from '@zxing/library';
import barcodeScannerTemplate from './barcodeScannerTemplate';
import errorTemplate from './errorTemplate';

const isSafari = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const userAgentString = window && window.navigator.userAgent;
  return (
    !/CriOS/.test(userAgentString)
    && !/FxiOS/.test(userAgentString)
    && !/OPT/.test(userAgentString)
    && !/EdgiOS/.test(userAgentString)
    && !/DuckDuckGo/.test(userAgentString)
    && !/Aloha/.test(userAgentString)
  );
};

const isIOS = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const iosUserAgents = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ];
  return iosUserAgents.includes(window.navigator.platform);
};

class BarcodeScanner {
  constructor() {
    this.captureMethod = BarcodeScanner.getCaptureMethod();
    this.codeReader = new BrowserMultiFormatReader();
  }

  handleSuccess() {
    const { captureMethod } = this;
    document.querySelector('video').dispatchEvent(new Event('pause'));
    const viewPortEle = document.querySelector('.barcode-scanner__view-port');
    if (viewPortEle) {
      viewPortEle.classList.add('barcode-scanner__view-port--success');
    }
  }

  initZXingVideo(resolve, reject) {
    if (typeof window === 'undefined') {
      return;
    }
    this.renderBody();
    this.renderVideoCapture();
    const navigator = window.navigator;

    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      this.codeReader.reset();
      this.codeReader
        .getVideoInputDevices()
        .then((videoInputDevices) => {
          /* Animation to bring in camera tip */
          setTimeout(function () {
            const howToElem = document.getElementById('js-bs-how-to');
            if (howToElem) {
              howToElem.classList.add('barcode-scanner--off-screen-up');
              howToElem.classList.remove('barcode-scanner__tip--hidden');
            }
          }, 200);

          this.codeReader
            .decodeOnceFromVideoDevice(undefined, 'video') // default to rear camera
            .then((result) => {
              this.codeReader.reset();
              this.handleSuccess(result);
              const { text } = result;
              resolve(text);
              setTimeout(() => {
                document.getElementById('js-close-barcode-scanner').click();
              }, 500);
            })
            .catch((err) => {
              // console.log(err);
              const { message = '' } = err;
              if (
                message === 'Requested device not found'
                || message.toUpperCase().includes('PERMISSION')
              ) {
                this.handleError({ code: 403, message: 'Camera permissions denied' });
              } else {
                this.handleError({ code: 408, message: 'We are unable to detect a code.' });
              }
            });
          // reject();
        })
        .catch((err) => {
          // console.log(err);
          this.handleError({ code: 403, message: 'Camera permissions denied' });
          // reject();
        });
    } else {
      // console.log('media device not found');
      this.handleError({ code: 403, message: 'Camera permissions denied' });
    }
  }

  // initZXingImage() {
  //   this.renderBody();
  //   this.renderCameraInput();

  //   document.getElementById('js-bs__image-capture-display')?.remove();
  // }

  // detectBarcodeFromStaticImage() {
  //   const imageToCheck = document.getElementById('js-bs__image-capture-display');
  //   this.codeReader
  //     .decodeFromImage(imageToCheck)
  //     .then((result) => {
  //       this.handleSuccess(result);
  //     })
  //     .catch((err) => {
  //       this.handleError({ code: 408, message: 'We are unable to detect a code.' });
  //     });
  // }

  handleError({ code, message, searchTerm, semanticTokens }) {
    const viewPortEle = document.querySelector('.barcode-scanner__view-port');

    if (viewPortEle) {
      viewPortEle.classList.add('barcode-scanner__view-port--error');
      viewPortEle.appendChild(errorTemplate({ code, message }));
    }

    /* Hide Tip */
    const howToEle = document.getElementById('js-bs-how-to');
    if (howToEle) {
      howToEle.classList.add('barcode-scanner__tip--hidden');
    }
    const _self = this;
    const resetBarcodeBtn = document.getElementById('resetBarcodeScanner');
    if (resetBarcodeBtn) {
      resetBarcodeBtn.addEventListener('click', function callResetScanner() {
        resetBarcodeBtn.removeEventListener('click', callResetScanner);
        _self.resetScanner();
      });
    }
  }

  resetScanner() {
    const { captureMethod } = this;
    const viewPortEle = document.querySelector('.barcode-scanner__view-port');

    // remove errorTemplate
    const errEle = document.getElementById('js-bs-error');
    if (errEle) {
      errEle.remove();
    }
    if (viewPortEle) {
      viewPortEle.classList.remove('barcode-scanner__view-port--error');
    }

    if (captureMethod === 'video') {
      this.initZXingVideo();
    }
    // else if (captureMethod === 'image') {
    //   this.initZXingImage();
    // }
  }

  // renderCameraInput() {
  //   if (document.getElementById('js-barcode-scanner__input-wrapper') === null) {
  //     document.getElementById('js-barcode-scanner__wrapper').innerHTML += inputTemplate;
  //   }

  //   const _this = this;
  //   const inputElement = document.getElementById('js-barcode-scanner__input');
  //   inputElement.addEventListener('change', (event) => {
  //     /* If user submitted image is already present, remove */
  //     const { files = [] } = event.target;
  //     this.renderCapturedImage({
  //       imageFile: files[0],
  //       barcodeScannerInstance: _this,
  //     });
  //   });
  // }

  // renderCapturedImage({ imageFile, barcodeScannerInstance }) {
  //   /* Exit barcode scanner if user selects cancel from within camera view */
  //   if (!imageFile) {
  //     document.getElementById('js-close-barcode-scanner')?.dispatchEvent(new Event('click'));
  //   } else {
  //     /* Hide input button */
  //     document.getElementById('js-barcode-scanner__input-wrapper')?.remove();

  //     const blobURL = window.URL.createObjectURL(imageFile);
  //     const image = document.createElement('img');
  //     image.id = 'js-bs__image-capture-display';
  //     image.className = 'barcode-scanner__image-capture';
  //     image.src = blobURL;
  //     document.getElementById('js-bs__image-capture')?.appendChild(image);

  //     barcodeScannerInstance.detectBarcodeFromStaticImage();
  //   }
  // }

  renderVideoCapture() {
    const { captureMethod } = this;
    if (document.getElementById('video') === null) {
      const video = document.createElement('video');
      video.id = 'video';
      video.className = 'barcode-scanner__video';
      const imgEle = document.getElementById('js-bs__image-capture');
      if (imgEle) {
        imgEle.appendChild(video);
      }
    }
  }

  renderBody() {
    const _self = this;
    if (document.getElementById('js-barcode-scanner__wrapper') === null) {
      const { captureMethod } = this;
      const wrapper = document.createElement('div');
      wrapper.id = 'js-barcode-scanner__wrapper';
      wrapper.innerHTML = barcodeScannerTemplate({
        showTip: captureMethod === 'video'
      });
      document.body.appendChild(wrapper);

      document.body.classList.add('bs-no-scroll');

      /* Click event to close barcode scanner */
      const closeEle = document.getElementById('js-close-barcode-scanner');
      if (closeEle) {
        closeEle.addEventListener('click', function () {
          _self.stopScanning();
        });
      }
      /* _____ Cache Busting _____
         Binding method to close barcode scanner if user
         returns from /s/ or /p/ with the back button
      */
      if (typeof window === 'undefined') {
        return;
      }

      window.addEventListener('pageshow', function (event) {
        const ele = document.getElementById('js-close-barcode-scanner');
        if (event.originalEvent.persisted && ele) {
          ele.dispatchEvent(new Event('click'));
          _self.stopScanning();
        }
      });
    }
  }

  startScanning() {
    const { captureMethod } = this;
    if (captureMethod === 'video') {
      return new Promise((resolve, reject) => {
        this.initZXingVideo(resolve, reject);
      });
    }
    return null;
    // else {
    //   this.initZXingImage();
    // }
  }

  stopScanning() {
    this.codeReader.reset();
    document.body.classList.remove('bs-no-scroll');
    const imgEle = document.getElementById('js-bs__image-capture');
    if (imgEle) {
      imgEle.remove();
    }
    const wrapperEle = document.getElementById('js-barcode-scanner__wrapper');
    if (wrapperEle) {
      wrapperEle.remove();
    }
  }

  static getCaptureMethod() {
    if (typeof window === 'undefined') {
      return null;
    }

    const isEnumerateDevicesAvailable = window.navigator.mediaDevices && window.navigator.mediaDevices.enumerateDevices;

    const captureMethod = !isEnumerateDevicesAvailable && isIOS() && !isSafari() ? 'image' : 'video';

    return captureMethod;
  }
}

export default BarcodeScanner;
